import { HttpService } from "../http/HttpService";
import { UpcomingCashback } from "../http/protocol";

export class UpcomingCashbackService {
  constructor(private http: HttpService) {}

  getForUser(userId: number): Promise<UpcomingCashback[]> {
    return this.http.get(`/cashback/next-upcoming/${userId}`);
  }
}
